export default {
  primerSingle: "Nuestro primer single:",
  nouSingle: "Nuevo single disponible en todas las plataformas:",
  primerEP: "Escucha nuestro primer EP:",
  iMes: "...y más",
  presave: "Pre-save",
  spotify: "Spotify",
  youtube: "Youtube",
  soundcloud: "Soundcloud",
  amazonMusic: "Amazon Music",
  appleMusic: "Apple Music",
  videoDisponible: "Videoclip disponible en Youtube:",
  contacte: "Contacto:",
  avisLegal: "Aviso legal",
  politicaPrivacitat: "Política de privacidad",
  politicaCookies: "Política de cookies",
  textAvisLegal: `<h1>AVISO LEGAL</h1>
                  <p>
                    En el presente Aviso Legal, el Usuario, podrá encontrar toda la
                    información relativa a las condiciones legales que definen las relaciones
                    entre los usuarios y el responsable de la página web accesible en la
                    dirección URL
                    <a class="hoverable" href="https://onesbanda.com/"
                      >https://onesbanda.com</a
                    >
                    (en adelante, el sitio web), que <strong>ONES</strong> pone a disposición
                    de los usuarios de Internet.
                  </p>
                  <p>
                    La utilización del sitio web implica la aceptación plena y sin reservas de
                    todas y cada una de las disposiciones incluidas en este Aviso Legal. En
                    consecuencia, el usuario del sitio web debe leer atentamente el presente
                    Aviso Legal en cada una de las ocasiones en que se proponga utilizar la
                    web, ya que el texto podría sufrir modificaciones a criterio del titular
                    de la web, o a causa de un cambio legislativo, jurisprudencial o en la
                    práctica empresarial.
                  </p>
                  <h3><strong>Responsable:</strong></h3>
                  <p>
                    Razón Social: Vicent Mayans Roca<br />NIF: 20845345P<br />Dirección: Plaça
                    del Regne, 5, 46600 Alzira, Valencia<br />Teléfono:
                    <a class="hoverable" href="tel:+34618118469">+34 618118469</a><br />Correo
                    electrónico:
                    <a class="hoverable" href="mailto:info{'@'}onesbanda.com"
                      >info{'@'}onesbanda.com</a
                    >
                  </p>
                  <p>
                    Este Sitio Web garantiza la protección y confidencialidad de los datos
                    personales que nos proporcionen de acuerdo con lo dispuesto en el
                    Reglamento General de Protección de Datos de Carácter Personal (UE)
                    2016/679 del Parlamento Europeo.
                  </p>
                  <h3><strong>Objeto:</strong></h3>
                  <p>
                    El sitio web facilita a los usuarios del mismo el acceso a información y
                    servicios prestados por ONES a aquellas personas u organizaciones
                    interesadas en los mismos.
                  </p>
                  <p>
                    El acceso y la utilización del Sitio Web atribuye la condición de usuario
                    del Sitio Web (en adelante, el “Usuario”) e implica la aceptación de todas
                    las condiciones incluidas en este Aviso Legal así como de sus
                    modificaciones. La prestación del servicio del Sitio Web tiene una
                    duración limitada al momento en el que el Usuario se encuentre conectado
                    al Sitio Web o a alguno de los servicios que a través del mismo se
                    facilitan. Por tanto, el Usuario debe leer atentamente el presente Aviso
                    Legal en cada una de las ocasiones en que se proponga utilizar el Sitio
                    Web, ya que éste y sus condiciones de uso recogidas en el presente Aviso
                    Legal pueden sufrir modificaciones.
                  </p>
                  <h3><strong>Acceso y utilización de la web</strong>:</h3>
                  <ul>
                    <li>
                      Carácter gratuito del acceso y utilización de la web. El acceso a la web
                      tiene carácter gratuito para los usuarios de la misma, salvo en lo
                      relativo al coste de la conexión a través de la red de
                      telecomunicaciones suministrada por el proveedor de acceso contratado
                      por los usuarios.
                    </li>
                    <li>
                      Registro de usuarios. Con carácter general el acceso y utilización de la
                      web no exige la previa suscripción o registro de los usuarios de la
                      misma.
                    </li>
                    <li>
                      Los usuarios garantizan y responden, en cualquier caso, de la exactitud,
                      vigencia y autenticidad de los datos personales facilitados, y se
                      comprometen a mantenerlos debidamente actualizados. El usuario acepta
                      proporcionar información completa y correcta en el formulario de
                      contacto o suscripción.
                    </li>
                  </ul>
                  <p>
                    En ningún caso se recabarán del menor de edad datos relativos a la
                    situación profesional, económica o a la intimidad de los otros miembros de
                    la familia, sin el consentimiento de éstos. Si eres menor de trece años y
                    has accedido a este sitio web sin avisar a tus padres no debes registrarte
                    como usuario.
                  </p>
                  <p>
                    En esta web se respetan y cuidan los datos personales de los usuarios.
                    Como usuario debes saber que tus derechos están garantizados.
                  </p>
                  <h3><strong>Contenidos de la web</strong>:</h3>
                  <p>
                    El idioma utilizado por el titular en la web será el valenciano o el
                    castellano. <strong>ONES </strong>no se responsabiliza de la no
                    comprensión o entendimiento del idioma de la web por el usuario, ni de sus
                    consecuencias.
                  </p>
                  <p>
                    <strong>ONES</strong> podrá modificar los contenidos sin previo aviso, así
                    como suprimir y cambiar éstos dentro de la web, como la forma en que se
                    accede a éstos, sin justificación alguna y libremente, no
                    responsabilizándose de las consecuencias que los mismos puedan ocasionar a
                    los usuarios.
                  </p>
                  <p>
                    Se prohíbe el uso de los contenidos de la web para promocionar, contratar
                    o divulgar publicidad o información propia o de terceras personas sin la
                    autorización de <strong>ONES</strong>, ni remitir publicidad o información
                    valiéndose para ello de los servicios o información que se ponen a
                    disposición de los usuarios, independientemente de si la utilización es
                    gratuita o no.
                  </p>
                  <p>
                    Los enlaces o hiperenlaces que incorporen terceros en sus páginas web,
                    dirigidos a esta web, serán para la apertura de la página web completa, no
                    pudiendo manifestar, directa o indirectamente, indicaciones falsas,
                    inexactas o confusas, ni incurrir en acciones desleales o ilícitas en
                    contra de <strong>ONES.</strong>
                  </p>
                  <h3><strong>Medidas de seguridad:</strong></h3>
                  <p>
                    Los datos personales comunicados por el usuario podrán ser almacenados en
                    bases de datos automatizadas o no, cuya titularidad corresponde en
                    exclusiva a <strong>ONES</strong>, asumiendo todas las medidas de índole
                    técnica, organizativa y de seguridad que garanticen la confidencialidad,
                    integridad y calidad de la información contenida en las mismas de acuerdo
                    con lo establecido en las normativas vigentes en materia de protección de
                    datos de carácter personal.
                  </p>
                  <h3><strong>Limitación de responsabilidad:</strong></h3>
                  <p>
                    Tanto el acceso a la web como el uso no consentido que pueda efectuarse de
                    la información contenida en la misma es de la exclusiva responsabilidad de
                    quien lo realiza. <strong>ONES</strong> no responderá de ninguna
                    consecuencia, daño o perjuicio que pudieran derivarse de dicho acceso o
                    uso. <strong>ONES</strong> no se hace responsable de los errores de
                    seguridad, que se puedan producir ni de los daños que puedan causarse al
                    sistema informático del usuario (hardware y software), o a los ficheros o
                    documentos almacenados en el mismo, como consecuencia de:
                  </p>
                  <ul>
                    <li>
                      la presencia de un virus en el ordenador del usuario que sea utilizado
                      para la conexión a los servicios y contenidos de la web.
                    </li>
                    <li>un mal funcionamiento del navegador.</li>
                    <li>y/o del uso de versiones no actualizadas del mismo.</li>
                  </ul>
                  <p>
                    <strong>ONES</strong> no se hace responsable de la fiabilidad y rapidez de
                    los hiperenlaces que se incorporen en la web para la apertura de otras.
                    <strong>ONES</strong> no garantiza la utilidad de estos enlaces, ni se
                    responsabiliza de los contenidos o servicios a los que pueda acceder el
                    usuario por medio de estos enlaces, ni del buen funcionamiento de estas
                    webs.
                  </p>
                  <p>
                    <strong>ONES</strong> no será responsable de los virus o demás programas
                    informáticos que deterioren o puedan deteriorar los sistemas o equipos
                    informáticos de los usuarios al acceder a su web u otras webs a las que se
                    haya accedido mediante enlaces de esta web.
                  </p>
                  <h3><strong>Empleo de la tecnología «Cookie»:</strong></h3>
                  <p>
                    El Sitio Web puede emplear cookies o tecnologías similares que se regirán
                    por lo establecido en la
                    <a class="hoverable" href="https://onesbanda.com/politica-cookies/"
                      >Política de Cookies</a
                    >, accesible en todo momento y respetando la confidencialidad e intimidad
                    del usuario, siendo parte integrante del presente Aviso Legal.
                  </p>
                  <h3><strong>Navegación:</strong></h3>
                  <p>
                    Los servidores de Internet pueden recoger datos no identificables, que
                    puedan incluir, direcciones IP, y otros datos que no pueden ser utilizados
                    para identificar al usuario. Su dirección IP se almacenará en los logs de
                    acceso de forma automática y con la única finalidad de permitir el
                    tránsito por Internet, siendo necesario que su equipo facilite esta
                    dirección IP cuando navega por Internet para que las comunicaciones puedan
                    realizarse. Asimismo, la dirección IP podrá ser utilizada para realizar
                    estadísticas, de manera anonimizada, sobre el número de visitantes de esta
                    web y su procedencia, de forma totalmente transparente a su navegación.
                  </p>
                  <h3><strong>Propiedad intelectual e industrial:</strong></h3>
                  <p>
                    El usuario conoce y acepta que todos los contenidos y/o cualesquiera otros
                    elementos del sitio web son propiedad de <strong>ONES</strong>, y se
                    compromete a respetar los derechos de propiedad intelectual e industrial
                    titularidad de <strong>ONES</strong>. Cualquier uso de la web o sus
                    contenidos deberá tener un carácter exclusivamente particular.
                  </p>
                  <p>
                    Está reservado exclusivamente a <strong>ONES</strong>, cualquier otro uso
                    que suponga la copia, reproducción, distribución, transformación,
                    comunicación pública o cualquier otra acción similar, de todo o parte de
                    los contenidos de la web, por lo que ningún usuario podrá llevar a cabo
                    estas acciones sin la autorización previa y por escrito de
                    <strong>ONES.</strong>
                  </p>
                  <h3><strong>Legislación aplicable y jurisdicción competente:</strong></h3>
                  <p>
                    El presente Aviso Legal se interpretará y regirá de conformidad con la
                    legislación española. <strong>Vicent Mayans Roca (ONES)</strong> y los
                    usuarios, con renuncia expresa a cualquier otro fuero que pudiera
                    corresponderles, se someten al de los juzgados y tribunales del domicilio
                    del usuario para cualquier controversia que pudiera derivarse del acceso o
                    uso de la web. En el caso de que el usuario tenga su domicilio fuera de
                    España, <strong><strong>Vicent Mayans Roca (ONES)</strong></strong> y el
                    usuario, se someten, con renuncia expresa a cualquier otro fuero, a los
                    juzgados y tribunales del domicilio de la<strong> </strong>Comunidad
                    Valenciana.
                  </p>`,
  textPoliticaPrivacitat: `<h1>POLÍTICA DE PRIVACIDAD</h1>
                          <p>
                            Según lo establecido en el RGPD (Reglamento (UE) 2016/679), les
                            proporcionamos la Información Detallada de Protección de Datos que se
                            expone a continuación:
                          </p>
                          <h3><strong>Responsable:</strong></h3>
                          <p>
                            Razón Social: Vicent Mayans Roca<br />NIF: 20845345P<br />Dirección: Plaça
                            del Regne, 5, 46600 Alzira, Valencia<br />Teléfono:
                            <a class="hoverable" href="tel:+34618118469">+34 618118469</a><br />Correo
                            electrónico:
                            <a class="hoverable" href="mailto:info{'@'}onesbanda.com"
                              >info{'@'}onesbanda.com</a
                            >
                          </p>
                          <h3><strong>Finalidad:</strong></h3>
                          <p>
                            Le informamos que los Datos de Carácter Personal recogidos, serán
                            incorporados a un Fichero bajo nuestra responsabilidad, con la finalidad
                            de gestionar el envío de la información que nos soliciten y facilitar a
                            los interesados ofertas de productos y servicios de su interés (así como
                            realizar la facturación de los productos adquiridos en nuestra Página
                            Web). Los datos proporcionados se conservarán mientras se mantenga la
                            relación comercial, durante los años necesarios para cumplir con las
                            obligaciones legales o se solicite su supresión por el interesado.
                          </p>
                          <h3><strong>Legitimación:</strong></h3>
                          <p>
                            Los Datos de Carácter Personal obtenidos en esta Página Web, así como la
                            oferta de productos y servicios ofrecidos, está basada en el
                            consentimiento que se le solicita al interesado.
                          </p>
                          <p>
                            El interesado tendrá derecho a retirar su consentimiento en cualquier
                            momento. La retirada del consentimiento no afectará a la licitud del
                            tratamiento basada en el consentimiento previo a su retirada.
                          </p>
                          <h3><strong>Destinatarios:</strong></h3>
                          <p>No se cederán datos a terceros, salvo obligación legal.</p>
                          <h3><strong>Derechos:</strong><br /></h3>
                          <p>
                            Usted como interesado directo, tiene derecho a obtener confirmación sobre
                            si en <strong>ONES</strong> estamos tratando datos personales que le
                            conciernen, o no. Usted tiene derecho a acceder a sus datos personales,
                            así como a solicitar la rectificación de los datos inexactos o, en su
                            caso, solicitar su supresión cuando, entre otros motivos, los datos ya no
                            sean necesarios para los fines que fueron recogidos.
                          </p>
                          <p>
                            En determinadas circunstancias, usted podrá solicitar la limitación del
                            tratamiento de sus datos, en cuyo caso únicamente los conservaremos para
                            el ejercicio o la defensa de reclamaciones.
                          </p>
                          <p>
                            En determinadas circunstancias y por motivos relacionados con su situación
                            particular, usted podrá oponerse al tratamiento de sus datos.
                            <strong>ONES</strong>
                            dejará de tratar los datos, salvo por motivos legítimos imperiosos, o el
                            ejercicio o la defensa de posibles reclamaciones.
                          </p>
                          <p>
                            En determinadas circunstancias, usted tendrá derecho a recibir los datos
                            personales que le incumban y que nos haya facilitado, y transmitirlos o
                            solicitar que se los proporcionemos a un tercero sin objeción por nuestra
                            parte (derecho a la portabilidad de datos).
                          </p>
                          <p>
                            En determinadas circunstancias, le informamos que tendrá derecho a no ser
                            objeto de una decisión basada únicamente en el tratamiento automatizado,
                            incluida la elaboración de perfiles, que produzca efectos jurídicos sobre
                            usted o le afecte significativamente de modo similar.
                          </p>
                          <p>
                            Si necesitas cualquier aclaración sobre este tema, por favor, no dudes en
                            contactarnos a través del correo
                            <a class="hoverable" href="mailto:info{'@'}onesbanda.com">info{'@'}onesbanda.com</a>
                          </p>`,
  textPoliticaCookies: `<h1>POLÍTICA DE COOKIES</h1>
                        <p><strong>¿Qué son las cookies?</strong></p>
                        <p>
                          Una cookie es un fichero que se descarga en su ordenador al acceder a
                          determinadas páginas web. Las cookies permiten a una página web, entre
                          otras cosas, almacenar y recuperar información sobre los hábitos de
                          navegación de un usuario o de su equipo y, dependiendo de la información
                          que contengan y de la forma en que utilice su equipo, pueden utilizarse
                          para reconocer al usuario.
                        </p>
                        <p><strong>¿Qué tipos de cookies utiliza esta página web?</strong></p>
                        <ul>
                          <li>
                            Cookies propias: Son aquéllas que se envían al equipo terminal del
                            usuario desde un equipo o dominio gestionado por el propio editor y
                            desde el que se presta el servicio solicitado por el usuario.
                          </li>
                          <li>
                            Cookies de terceros: Son aquéllas que se envían al equipo terminal del
                            usuario desde un equipo o dominio que no es gestionado por el editor,
                            sino por otra entidad que trata los datos obtenidos través de las
                            cookies.
                          </li>
                          <li>
                            Cookies de sesión: Son un tipo de cookies diseñadas para recabar y
                            almacenar datos mientras el usuario accede a una página web.
                          </li>
                          <li>
                            Cookies persistentes: Son un tipo de cookies en el que los datos siguen
                            almacenados en el terminal y pueden ser accedidos y tratados durante un
                            periodo definido por el responsable de la cookie, y que puede ir de unos
                            minutos a varios años.
                          </li>
                          <li>
                            Cookies de análisis: Son aquéllas que bien tratadas por nosotros o por
                            terceros, nos permiten cuantificar el número de usuarios y así realizar
                            la medición y análisis estadístico de la utilización que hacen los
                            usuarios del servicio ofertado. Para ello se analiza su navegación en
                            nuestra página web con el fin de mejorar la oferta de productos o
                            servicios que le ofrecemos.
                          </li>
                        </ul>
                        <p><strong>¿Cómo gestionar las cookies?</strong></p>
                        <p>
                          Usted puede permitir, bloquear o eliminar las cookies instaladas en su
                          equipo mediante la configuración de las opciones del navegador instalado
                          en su ordenador, en caso que no permita la instalación de cookies en su
                          navegador es posible que no pueda acceder a alguna de las secciones de
                          nuestra web.
                        </p>`,
};
